export const FETCH_REQUEST_TRAVELS = "FETCH_REQUEST_TRAVELS";
export const FETCH_REQUEST_TRAVEL = "FETCH_REQUEST_TRAVEL";
export const EDIT_REQUEST_TRAVEL = "EDIT_REQUEST_TRAVEL";
